"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var _require = require('underscore'),
  last = _require.last,
  first = _require.first;
var PAGE_LIMIT = 10;
var OrgEntitlementTransactions = /*#__PURE__*/function () {
  OrgEntitlementTransactions.$inject = ["$rootScope", "$scope", "entitlementsService"];
  /* @ngInject */
  function OrgEntitlementTransactions($rootScope, $scope, entitlementsService) {
    _classCallCheck(this, OrgEntitlementTransactions);
    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.entitlementsService = entitlementsService;
  }

  /**
   * Initializes data
   */
  _createClass(OrgEntitlementTransactions, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      this.getOrganizationTransactions().then(function (transactionsPage) {
        _this.transactionsPage = transactionsPage;
      }).catch(function (err) {
        console.error(err);
        _this.transactionsPage = {
          error: 'An error occured getting transactions information.'
        };
      });
      this.$scope.$on('LOAD_PREVIOUS_TRANSACTION_PAGE', function () {
        var firstTransaction = first(_this.transactionsPage.items);
        _this.getOrganizationTransactions({
          startAt: firstTransaction._id
        }).then(function (transactionsPage) {
          _this.transactionsPage = transactionsPage;
        }).catch(function (err) {
          console.error(err);
          _this.$rootScope.setFlashMessage('An error occured getting transactions information.', 'danger');
        });
      });
      this.$scope.$on('LOAD_NEXT_TRANSACTION_PAGE', function () {
        var lastTransaction = last(_this.transactionsPage.items);
        _this.getOrganizationTransactions({
          endAt: lastTransaction._id
        }).then(function (transactionsPage) {
          _this.transactionsPage = transactionsPage;
        }).catch(function (err) {
          console.error(err);
          _this.$rootScope.setFlashMessage('An error occured getting transactions information.', 'danger');
        });
      });
    }

    /**
     * Fetches the transactions history for the current organization
     *
     * @param {object} page - The object specifying the pagination
     */
  }, {
    key: "getOrganizationTransactions",
    value: function getOrganizationTransactions() {
      var _this2 = this;
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        first: true
      };
      if (this.loading) return;
      this.loading = true;
      return this.entitlementsService.getOrganizationTransactions(this.organisation._id, [this.entitlementsService.TYPE_ACCOUNT, this.entitlementsService.TYPE_TRANSACTION, this.entitlementsService.TYPE_EXPIRED], Object.assign(page, {
        limit: PAGE_LIMIT
      })).then(function (transactionsPage) {
        return transactionsPage;
      }).finally(function () {
        _this2.loading = false;
      });
    }
  }]);
  return OrgEntitlementTransactions;
}();
module.exports = angular.module('backstage.components.orgs.view-org.entitlements-manager.org-entitlement-transactions', ['backstage.services']).component('bsOrgEntitlementTransactions', {
  templateUrl: '/src/angular/components/orgs/view-org/org-entitlements-manager/org-entitlement-transactions/org-entitlement-transactions.html',
  bindings: {
    organisation: '<'
  },
  controllerAs: 'vm',
  controller: OrgEntitlementTransactions
}).name;